import { render, staticRenderFns } from "./successMessage.vue?vue&type=template&id=44e4a4f9&scoped=true"
import script from "./successMessage.vue?vue&type=script&lang=js"
export * from "./successMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e4a4f9",
  null
  
)

export default component.exports